import { render, staticRenderFns } from "./compMessage.vue?vue&type=template&id=0a02f1a0&scoped=true"
import script from "./compMessage.vue?vue&type=script&lang=js"
export * from "./compMessage.vue?vue&type=script&lang=js"
import style0 from "./compMessage.vue?vue&type=style&index=0&id=0a02f1a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a02f1a0",
  null
  
)

export default component.exports